var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.65 198.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--primary-color);}.cls-2{fill:var(--primary-color);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.5,150.09H165.27a3.61,3.61,0,0,0-2.84,1.34,74.68,74.68,0,0,1-5.18,5.66,81.76,81.76,0,1,1,0-115.6c1.83,1.83,3.54,3.72,5.18,5.66a3.64,3.64,0,0,0,2.84,1.34H181.5a1.84,1.84,0,0,0,1.55-2.84,99.29,99.29,0,1,0,0,107.28A1.85,1.85,0,0,0,181.5,150.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202,97.83,169.18,72a1.85,1.85,0,0,0-3,1.46V91H93.67a1.86,1.86,0,0,0-1.84,1.85v12.93a1.85,1.85,0,0,0,1.84,1.85h72.51v17.55a1.85,1.85,0,0,0,3,1.45L202,100.74a1.84,1.84,0,0,0,.31-2.59A2.34,2.34,0,0,0,202,97.83Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9df4de8817e38abe6c5068e2a11df8c3.svg";
export { ForwardRef as ReactComponent };